import { createFileRoute } from '@tanstack/react-router'
import PaymentInformationList from 'Royalty/components/Reports/PaymentInformation/PaymentInformationList'

export const Route = createFileRoute('/royalty/paymentinformation/upcoming')({
    component: PaymentInformationList,
})
